var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewDiviceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8935",
    "data-name": "Group 8935",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4338",
    "data-name": "Rectangle 4338",
    width: 73,
    height: 73,
    rx: 8,
    fill: "#274c6b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8934",
    "data-name": "Group 8934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8752",
    "data-name": "Group 8752",
    transform: "translate(5.885 17.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8753",
    "data-name": "Group 8753",
    transform: "translate(32.629 -14.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4322",
    "data-name": "Rectangle 4322",
    transform: "translate(0 25.313)",
    fill: "#fff",
    stroke: "#274c6b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.434,
    height: 24.721,
    rx: 1.217,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 3.434,
    height: 25.721,
    rx: 1.717,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8754",
    "data-name": "Group 8754",
    transform: "translate(18.088 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8586",
    "data-name": "Path 8586",
    d: "M5.832,0H0",
    transform: "translate(3.914 22.141)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8587",
    "data-name": "Path 8587",
    d: "M10.2,0H0",
    transform: "translate(1.733 14.983)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8588",
    "data-name": "Path 8588",
    d: "M13.658,0H0",
    transform: "translate(0 7.714)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8767",
    "data-name": "Group 8767",
    transform: "translate(-25.045 9.657) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8586-2",
    "data-name": "Path 8586",
    d: "M5.832,0H0",
    transform: "translate(3.914 22.141)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8587-2",
    "data-name": "Path 8587",
    d: "M10.2,0H0",
    transform: "translate(1.733 14.983)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8588-2",
    "data-name": "Path 8588",
    d: "M13.658,0H0",
    transform: "translate(0 7.714)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4321",
    "data-name": "Rectangle 4321",
    transform: "translate(14.383 20.532)",
    fill: "#fff",
    stroke: "#274c6b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.263,
    height: 25.263,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 26.263,
    height: 26.263,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8869",
    "data-name": "Path 8869",
    d: "M4.356-.259A1.458,1.458,0,0,0,3.747-1.6L.589-3.822s-.572-.476-.6.5-.033,16.352,0,17.7S.486,15.9.486,15.9l3.267,4.553s.565.808.6-.538S4.346.75,4.356-.259Z",
    transform: "translate(8.339 22.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_8870",
    "data-name": "Path 8870",
    transform: "translate(42.737 19.639)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -27.17258644104004 -0.104655846953392 C -27.44937515258789 -0.104655846953392 -28.16711616516113 -0.1552858501672745 -28.85206604003906 -0.6241758465766907 C -29.41489601135254 -1.009455800056458 -31.94993591308594 -2.60472583770752 -32.28249740600586 -2.809285879135132 C -32.82779693603516 -3.144735813140869 -32.93163681030273 -3.657795906066895 -32.84698486328125 -4.026095867156982 C -32.79155731201172 -4.267275810241699 -32.5629768371582 -4.838205814361572 -31.63995552062988 -4.930505752563477 L -31.59286499023438 -4.935215950012207 L -31.54555511474609 -4.935455799102783 C -31.41035652160645 -4.936145782470703 -18.00534629821777 -5.004355907440186 -16.23546600341797 -5.004355907440186 C -16.16165542602539 -5.004355907440186 -16.10717582702637 -5.004235744476318 -16.07327651977539 -5.004005908966064 C -15.27442741394043 -4.9985032081604 -14.8001127243042 -4.864112854003906 -14.55915451049805 -4.765833377838135 L -6.501550674438477 -2.562243461608887 C -6.443318843841553 -2.548571825027466 -6.297461986541748 -2.512974739074707 -6.147145748138428 -2.465725898742676 C -6.008995532989502 -2.422305822372437 -5.894925594329834 -2.377865791320801 -5.798415660858154 -2.329875946044922 C -5.269635677337646 -2.06691575050354 -5.123215675354004 -1.595985889434814 -5.162525653839111 -1.242955803871155 C -5.1902756690979 -0.9936658143997192 -5.35114574432373 -0.4009058475494385 -6.243305683135986 -0.2812458574771881 C -6.456345558166504 -0.2526658475399017 -6.754875659942627 -0.2387758493423462 -7.155935764312744 -0.2387758493423462 C -9.07426643371582 -0.2387758493423462 -26.30130958557129 -0.1126446574926376 -27.06839752197266 -0.1070194095373154 C -27.09561920166016 -0.1057168692350388 -27.13066291809082 -0.104655846953392 -27.17258644104004 -0.104655846953392 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -27.17258262634277 -1.104659199714661 C -27.12656784057617 -1.104659199714661 -27.10074615478516 -1.106805801391602 -27.10074615478516 -1.106805801391602 C -27.10074615478516 -1.106805801391602 -9.134366035461426 -1.238775849342346 -7.155935764312744 -1.238775849342346 C -5.177505493164062 -1.238775849342346 -6.746225833892822 -1.592435836791992 -6.746225833892822 -1.592435836791992 L -14.89458560943604 -3.82084584236145 C -14.89458560943604 -3.82084584236145 -15.22660541534424 -3.998145818710327 -16.08016586303711 -4.004025936126709 C -16.93368530273438 -4.009908199310303 -31.54045486450195 -3.935465812683105 -31.54045486450195 -3.935465812683105 C -31.54045486450195 -3.935465812683105 -32.11178588867188 -3.878335952758789 -31.7585563659668 -3.661045789718628 C -31.40532493591309 -3.443765878677368 -28.86185646057129 -1.842735886573792 -28.28718566894531 -1.449345827102661 C -27.8305778503418 -1.136767625808716 -27.35054969787598 -1.104659199714661 -27.17258262634277 -1.104659199714661 M -27.17258644104004 0.8953441381454468 C -27.63198661804199 0.8953441381454468 -28.5344352722168 0.8051341772079468 -29.41695594787598 0.200994148850441 C -29.9336051940918 -0.1526858508586884 -32.41231536865234 -1.7150958776474 -32.80642700195312 -1.957525849342346 C -33.62716674804688 -2.462415933609009 -34.02562713623047 -3.362285852432251 -33.82157516479492 -4.250085830688477 C -33.65471649169922 -4.976085662841797 -33.02011489868164 -5.797485828399658 -31.73945617675781 -5.925545692443848 L -31.64528656005859 -5.934956073760986 L -31.55064582824707 -5.935435771942139 C -31.41542625427246 -5.936125755310059 -18.00786590576172 -6.004355907440186 -16.23546600341797 -6.004355907440186 C -16.15862655639648 -6.004355907440186 -16.10190582275391 -6.004215717315674 -16.06661605834961 -6.003975868225098 C -15.19551849365234 -5.997978210449219 -14.60972499847412 -5.854007720947266 -14.24869823455811 -5.717653751373291 L -6.254235744476318 -3.531331777572632 C -6.171927928924561 -3.511703014373779 -6.013549327850342 -3.471973657608032 -5.847295761108398 -3.419715881347656 C -5.658665657043457 -3.36042594909668 -5.497025489807129 -3.296825885772705 -5.353145599365234 -3.225275754928589 C -4.537225723266602 -2.819515943527222 -4.072285652160645 -1.99798583984375 -4.168655872344971 -1.132315874099731 C -4.198515892028809 -0.8641758561134338 -4.43241548538208 0.4848141670227051 -6.110365867614746 0.7098841667175293 C -6.37151575088501 0.744914174079895 -6.703755855560303 0.7612241506576538 -7.155935764312744 0.7612241506576538 C -9.057855606079102 0.7612241506576538 -26.06362915039062 0.8856489658355713 -27.04330253601074 0.8928304314613342 C -27.08076286315918 0.8943274617195129 -27.12406349182129 0.8953441381454468 -27.17258644104004 0.8953441381454468 Z",
    stroke: "none",
    fill: "#274c6b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDiviceIcon);
export default __webpack_public_path__ + "static/media/newDiviceIcon.312ec66e611006547aa06cd5aef812c0.svg";
export { ForwardRef as ReactComponent };